var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('window-header'),_c('nav-form',{attrs:{"nuevo":false}}),_c('section',[_c('article',{staticStyle:{"height":"367px"}},[_c('field',{staticStyle:{"top":"9px","left":"5px"},attrs:{"name":"delegacion_id","widget":"m2o","searchable":"","label":"Delegación","placeholder":"","width":"130px","readonly":"","inputStyle":"text-align:center;font-weight:bold;"}}),_c('field',{staticStyle:{"top":"9px","left":"140px"},attrs:{"name":"ndoc","widget":"char","searchable":"","label":"Nº Liquid.","placeholder":"","width":"67px","readonly":_vm.mode == 'edit',"inputStyle":"text-align:center;font-weight:bold;"}}),_c('field',{staticStyle:{"top":"9px","left":"210px"},attrs:{"name":"fecha","type":"date","label":"F. Recepción","help":"Fecha","required":"","default":"today","width":"105px","searchable":""}}),_c('field',{staticStyle:{"top":"8px","left":"320px"},attrs:{"name":"representante_id","widget":"m2o","label":"Representante","placeholder":"Rep.","required":"","width":"220px","searchable":"","fields":[
          'comision_fija_liquidacion',
          'irpf',
          'iva',
          'penalizacion_forma_pago',
          { name: 'forma_pago_id', fields: ['descripcion'] }
        ]}}),_c('field',{staticStyle:{"top":"9px","left":"565px"},attrs:{"name":"divisa_id","widget":"m2o","searchable":"","label":"Liquidar en...","width":"90px","readonly":""}}),_c('r-tabs',{ref:"main-tabs",staticStyle:{"top":"55px","left":"0px","height":"310px"},attrs:{"wt":_vm.formData.wt,"buttons":['Facturas', 'Pie'],"classButton":{ disabled: !_vm.formData.representante_id }}},[_c('div',{staticClass:"tab"},[_c('field',{ref:"lineas",staticClass:"lineas",staticStyle:{"top":"10px","left":"4px","width":"648px"},attrs:{"name":"lineas","htSettings":_vm.facturas_customprop,"widget":"handsontable","fields":[
              {
                name: 'factura_cliente_id',
                fields: [
                  { name: 'delegacion_id', fields: ['nombre'] },
                  'ndoc',
                  'fecha',
                  { name: 'cliente_id', fields: ['nombre_comercial'] },
                  'total',
                  { name: 'divisa_id', fields: ['nombre'] },
                  'cambio',
                  { name: 'formapago_id', fields: ['descripcion'] }
                ]
              }
            ],"height":256,"minRows":18,"customprop":"facturas_customprop","readonly":"","columns":[
              {
                name: 'factura_cliente_id.delegacion_id',
                header: 'Del.',
                type: 'm2o',
                primary: 'codigo',
                readOnly: true
              },
              {
                name: 'factura_cliente_id.ndoc',
                header: 'NºDocumento',
                readOnly: true
              },
              {
                name: 'factura_cliente_id.cliente_id',
                header: 'Cliente',
                readOnly: true,
                type: 'm2o',
                primary: 'codigo',
                label: 'nombre_comercial',
                showCode: true
              },
              {
                name: 'factura_cliente_id.fecha',
                header: 'Fecha',
                type: 'date2',
                primary: 'codigo',
                readOnly: true
              },
              {
                name: 'factura_cliente_id.total',
                header: 'total',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
                readOnly: true
              },
              {
                name: 'factura_cliente_id.divisa_id',
                header: 'Divisa',
                type: 'm2o',
                primary: 'codigo',
                readOnly: true
              },
              {
                name: 'factura_cliente_id.cambio',
                header: 'Cambio',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
                readOnly: true
              },
              {
                name: 'factura_cliente_id.formapago_id',
                header: 'F.pago',
                readOnly: true,
                type: 'm2o',
                primary: 'codigo',
                label: 'descripcion'
              },
              {
                name: 'calculo',
                header: 'Cálculo',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
                readOnly: true
              },
              {
                name: 'comision',
                header: 'Comisión',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
                readOnly: true
              },
              { name: 'tipo_cobro', header: 'T.Cob.' },
              //penalizacion
              //cobrado
              {
                name: 'porcentaje_cobrado',
                header: '%Cob.',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
                readOnly: true
              },
              {
                name: 'liquidable',
                header: 'Liquidable',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
                readOnly: true
              },
              {
                name: 'liquidado',
                header: 'Pagado',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
                readOnly: true
              },
              {
                name: 'pendiente',
                header: 'Pendiente',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
                readOnly: true
              },
              {
                name: 'liquidar',
                header: 'Liquidar',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' }
              },
              {
                name: 'l',
                header: 'Liquidado',
                type: 'checkbox'
              }
            ]}})],1),_c('div',{staticClass:"tab"},[_c('field',{staticStyle:{"top":"10px","left":"20px"},attrs:{"name":"sunumerofactura","widget":"char","label":"Su Nº Factura","width":"110px"}}),_c('field',{staticStyle:{"top":"10px","left":"150px"},attrs:{"name":"fechasufactura","widget":"date","type":"date","label":"Fecha de su Factura","width":"110px"}}),_c('fieldset',{staticStyle:{"position":"relative","left":"10px","top":"50px","width":"250px","height":"61px"}},[_c('legend',[_vm._v("Tipo Nacionalidad")]),_c('field',{staticStyle:{"top":"23px","left":"15px"},attrs:{"name":"nacionalidad","widget":"radio","default":"union_europea","options":{
                Nacional: 'nacional',
                'Extracom.': 'extracomunitario',
                UE: 'union_europea'
              },"inline-label":""}})],1),_c('field',{staticStyle:{"top":"135px","left":"10px"},attrs:{"name":"observaciones","widget":"text","label":"Observaciones","width":"250px","height":"100px"}}),_c('fieldset',{staticStyle:{"position":"relative","left":"270px","top":"-42px","width":"345px","height":"240px"}},[_c('field',{staticStyle:{"top":"10px","right":"15px"},attrs:{"name":"importe_fijo","widget":"float","type":"number","dec":"2","label":"Importe fijo de comisión","inline-label":"","width":"67px","inputStyle":"text-align:right;","readonly":""}}),_c('field',{staticStyle:{"top":"38px","right":"15px"},attrs:{"name":"importe_calculado","widget":"float","type":"number","dec":"2","label":"Importe calculado de comisión","inline-label":"","width":"67px","inputStyle":"text-align:right;","readonly":""}}),_c('hr',{staticStyle:{"position":"absolute","top":"60px","right":"15px","width":"250px"}}),_c('field',{staticStyle:{"top":"78px","right":"15px"},attrs:{"name":"base_imponible","widget":"float","type":"number","dec":"2","label":"Base imponible","inline-label":"","width":"67px","inputStyle":"text-align:right;","readonly":""}}),_c('field',{staticStyle:{"top":"106px","right":"87px"},attrs:{"name":"ivap","widget":"float","type":"number","dec":"2","label":"IVA","inline-label":"","sufix":"%","width":"67px","inputStyle":"text-align:right;","readonly":""}}),_c('field',{staticStyle:{"top":"106px","right":"15px"},attrs:{"name":"iva","widget":"float","type":"number","dec":"2","width":"67px","inputStyle":"text-align:right;","readonly":""}}),_c('field',{staticStyle:{"top":"134px","right":"87px"},attrs:{"name":"irpfp","widget":"float","type":"number","dec":"2","label":"IRPF","inline-label":"","sufix":"%","width":"67px","inputStyle":"text-align:right;","readonly":""}}),_c('field',{staticStyle:{"top":"134px","right":"15px"},attrs:{"name":"irpf","widget":"float","type":"number","dec":"2","width":"67px","inputStyle":"text-align:right;","readonly":""}}),_c('hr',{staticStyle:{"position":"absolute","top":"160px","right":"15px","width":"250px"}}),_c('field',{staticStyle:{"bottom":"38px","right":"15px"},attrs:{"name":"total","widget":"float","type":"number","dec":"2","width":"150px","readonly":"","label":"Total a pagar","inline-label":"","inputStyle":"text-align:right; font-weight:normal; font-size: 1.4em!important;"}}),_c('field',{staticStyle:{"right":"15px","bottom":"10px"},attrs:{"name":"formapago","widget":"select","options":{
                Contado: 'contado',
                Transferencia: 'transferencia',
                Pagaré: 'pagare'
              },"inline-label":"","label":"Forma de pago","width":"150px"}})],1)],1)])],1)]),_c('v-collapse-wrapper',{ref:"main-collapse",attrs:{"active":true}},[_c('div',{directives:[{name:"collapse-toggle",rawName:"v-collapse-toggle"}],staticClass:"header"},[_vm._v(" Listado "),_c('div',{staticClass:"item-after"},[_vm._v(_vm._s(_vm.count))])]),_c('div',{directives:[{name:"collapse-content",rawName:"v-collapse-content"}],staticClass:"my-content"},[_c('hot-table',{ref:"hotTableComponent",attrs:{"settings":_vm.htSettings}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }